<template>
  <div class="base-text-input-mail">
    <input
      type="email"
      placeholder="test@mail.com"
      class="base-text-input-mail-class"
      maxlength="254"
      name="email"
      :value="value"
      @input="inputText"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseTextInputMail',

  props: {
    value: { type: String }
  },

  methods: {
    inputText(e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-text-input-mail {
  > .base-text-input-mail-class {
    @include font-size(18);
    height: 45px;
    border-radius: 5px;
    border: solid 2px #{$plus_bc_gray};
    background-color: #{$plus_white};
    padding: 2px 11px;
    box-sizing: border-box;
    &::placeholder {
      text-align: left;
      color: #{$plus_be_gray};
    }
  }
  @include selector-width('.base-text-input-mail-class', 410px);
}
</style>
